import { Content } from "@/@types/general";

import MovieCard from "../cards/MovieCard";

interface PersonContentProps {
  title: string;
  contents: Content[];
}

const PersonContent = ({ title, contents }: PersonContentProps): JSX.Element => {
  return (
    <section className={"rounded-5"}>
      <h2 className={"text-2xl font-semibold"}>{title}</h2>
      <div className={"movies-grid mt-5 max-xl:mt-6"}>
        {contents.map((content) => (
          <MovieCard key={content.id} {...content} />
        ))}
      </div>
    </section>
  );
};

export default PersonContent;
